<template>
    <b-input-group
        :append="append"
        :prepend="prepend"
    >
        <template v-if="!prepend && $slots.prepend">
            <slot name="prepend" />
        </template>

        <slot />

        <template v-if="!append && $slots.append">
            <slot name="append" />
        </template>
    </b-input-group>
</template>

<script>
import { BInputGroup } from 'bootstrap-vue'

export default {
    components: { BInputGroup },
    props: {
        append: { type: String },
        prepend: { type: String },
    },
}
</script>